
import {
	Component,
	Vue,
	Watch
} from "vue-property-decorator";
import axios from 'axios';
import CollapseItem from '@/components/collapse.vue';
import PageFooter from '@/components/page-footer.vue';
import Switch from '@/components/switch.vue';
import SkuList from '../components/sku-list.vue';
import UploadImg from '@/components/upload-img.vue';
import SelectRefundAddress from '../components/select-refund-address.vue';
import Message from '@/components/message.vue';
import previewImg from '@/components/previewImg.vue';
import Dialog from '@/components/dialog.vue';
import cutarrow from '@/components/cutarrow.vue';
import importSpecificationCoding from '../components/importSpecificationCoding.vue'
import draggable from 'vuedraggable'

import quillconfig from '@/utils/quill-config-shop';
import RadioButton from '@/components/radio-button.vue';
import {
	host,
	imgHost,
	maxspecifications
} from '@/utils/config';
import {
	getOssToken
} from '@/api/user'
import {
	freightSettlementTemplatefreightSettlementTemplateList,
	productClasslistTree,

	productscheduleProductCheck,
	productscheduleProductQualificationEdit,
	freightSettlementTemplatefreightSettlementTemplateInfo,

	productscheduleProductInfoCheck,
	productscheduleProductMaterialCheck,
	productscheduleProductAptitudeCheck,
	productscheduleProductLogisticsCheck
} from "@/api/order"
import {
	createProduct,
	updateProduct,

	productscheduleProductDetail,
	productList,
	productBuyerproductBuyerPageInit,
	productproductProviderSupplyPrice,
	productImgTemplateList,
} from '@/api/supplier';
import {
	providerLogisticsTplList,
	getExpressList,
	providerReturnAddressSelectItem,
	productfreightTemplateSelectitem,
} from '@/api/logistics'

import {
	getTimestamp
} from '@/utils/index'

import settlementFreight from "@/views/product/components/settlementFreight.vue"

import inspectInventory from "@/views/product/components/inspectInventory.vue"

// import refundAddressInfo from '@/views/logistics/components/refund-address-info.vue';

import logisticsDetail from "@/views/product/components/logisticsDetail.vue"
import {
	handleClipboard
} from '@/utils/clipboard'
import {
	getSearchDate,
	nextDay
} from "@/utils"
import html2canvas from 'html2canvas';
@Component({
	name: 'product-detail',
	components: {
		CollapseItem,
		PageFooter,
		'slz-switch': Switch,
		SkuList,
		UploadImg,
		SelectRefundAddress,
		'slz-message': Message,
		previewImg,
		'slz-dialog': Dialog,
		cutarrow,
		importSpecificationCoding,
		draggable,
		RadioButton,
		settlementFreight,
		inspectInventory,
		// refundAddressInfo,
		logisticsDetail,
	}
})
export default class ProductDetail extends Vue {
	private exchangeUrl = location.origin + '/image/server?url=';
	private pageloading = false
	private arrowlist: any = [
		{ value: 0, label: '商品资料', type: '' },
		{ value: 1, label: '商品素材（图文详情）', type: '' },
		{ value: 2, label: '商品资质文件', type: '' },
		{ value: 3, label: '物流服务', type: '' },
	]
	private url = imgHost
	private type = this.$route.query.type;
	private isLook = false
	private isLook2 = this.$route.query.isLook2 ? true : false;
	private id = '';
	private isCheck = +this.$route.query.isCheck || 0;
	private search = ''
	private chooseTab = 0;
	private ProductInfo = {}
	private units: any = [];
	private selectVal = '';
	private isPageLoading = false;
	private showMessage = false;
	private selectList = [{
		label: '内容',
		value: '值'
	}, {
		label: '内容2',
		value: '值2'
	}
	]
	private pickerOptions: any = {
		shortcuts: [{
			text: '今天',
			onClick(picker: any) {
				picker.$emit('pick', new Date());
			}
		}, {
			text: '昨天',
			onClick(picker: any) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				picker.$emit('pick', date);
			}
		}, {
			text: '一周前',
			onClick(picker: any) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit('pick', date);
			}
		}]
	}


	private inputVisible = false;
	private inputValue = '';

	private list: any = []
	private formData: any = {}
	private scopeProfile = {
		IsFirstCheck: false,
		OpenTime: '',
		TakedownTime: '',
		IsNewThirdRoleGradeExclusive: false,
		IsCanBuyFreightInsurance: false,
		IsPushCrossErp: false,
		IsExchangeBuyProduct: false,
		IsThroughZoneProduct: false,
		IsOpenDamageReshipment: false,
		IsOpen: false, // 是否上架,
		IsCanCancel: true, //是否能取消,
		IsHaveOrderFee: true, // 是否含服务费
		IsShowDataColumn: true,//是否显示在日期栏下
		IsCanUseWaitDrawBalance: true,//是否允许使用购物金
		IsCanSearch: true,//允许被搜索


		ProductName: '', // 商品名称,
		ProviderId: '', //所属供应商,
		BuyLimit: '', //购买限制,
		MinPurchase: '', //最低起购数
		ProductUnitId: '', // 单位Id,
		SpecTitle: '', // 规格1标题,
		SpecTitle2: '', // 规格2标题,
		SpecTitle3: '', // 规格3标题,
		SpecTitle4: '',
		SpecTitle5: '',
		FreightTemplateId: '', // 物流模板Id,
		ProviderReturnAddressId: '', // 退货地址Id,
		ProductTags: [], // 商品标签,
		RetailCheckTime: 72, // 零售审核时长,
		FirstRoleCheckTime: 72, // 联创审核时长,
		SecondRoleCheckTime: 72, //核心审核时长,
		ThirdRoleCheckTime: 72, //总代审核时长,
		ProductSpecList: [], // 商品规格信息,
		SpecImgSelectLeve: '', // 规格图选择的规格层级
		sku: [],
		GoodsAmountMarginRate: 80, //商品货款质保金比例,
		GoodsAmountSettlePeriod: 60, //货款结算周期,
		MarginSettlePeriod: 60, //质保金结算周期,
		AfterSalePeriod: 30, //商品售后周期
		ProductType: 0,//0普通商品 1组合商品
		IsIncludedSubmitOrderInfo: false,//是否计入交单信息
		ProductMixInfoList: [],
		IsShareStock: false,
		SellPoint: '',
		SpecBacthDataList: [],
		IsOpenChangeProduct: true,
		IsOpenRefundProduct: true,
		IsOpenOnlyRefundMoney: true,
		MainSpecSelectLeve: '',//主规格选择的规格层级
		AddressLimitQuantity: '',
		PhoneLimitQuantity: '',
		ProductNo: '',
		IsCrossBorderProduct: false,
		FreightSettlementTemplateId: '',
		TemplateName: '',
		FreightSettlementType: 1,
		FreightSettlementTemplateDetailList: [],
		CanSubmitOrderRoleGradeList: [1, 2, 3, 0],
		ProductBuyerId: null,
		OwnBrandProductId: '',
		ProductClassId: [],
		SettlementType: 0,
		ProductInfoState: '',// ['待提交:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品资料状态,
		ProductInfoRejectReason: '',
		ProductScheduleApplyState: '',//['待提交:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品排期申请状态,
		SenderPhone: '',
	}
	private scopeMaterial = {
		ProductThumbImgUrl: [], //首页商品图,
		Video: [], //视频,
		ImgUrl: [], //商品主图,
		NoWatermarkImgUrl: [],//商品主图 无水印
		Details: [], //商品详情页,
		ProductDetail: '',
		ProductInfo: [],
		ProductMaterialState: '',//['待完善:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品素材状态,
		ProductMaterialRejectReason: '',
		ProductImgTemplateId: null,
	}
	private scopeAptitude = {
		ProductSixFaceRealPicture: [],
		BrandLicensingLink: [],
		ProductCommitmentLetter: [],
		ExaminingReport: [],
		ProductionEntrustCertificate: [],
		SupplementaryMaterial: [],
		ReplenishTemplate: [],
		TradeMarkRegistrationCertificate: [],
		ProductAptitudeState: '',//['待完善:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品资质状态,
		ProductAptitudeRejectReason: '',
	}
	//物流
	private scopeLogistics = {
		ExpressDeliveryList: [],
		DeliveryTime: 2,
		IsSplitDelivery: false,
		IsColdChainDelivery: false,
		IsFriability: false,
		PlaceOfDispatch: '',
		FreightRule: '',
		PrivacyWaybillImgUrlList: [],
		PrivacyWaybillRemark: '',
		PackagedVideoList: [],
		PackagedVideoRemark: '',
		WeighImgUrlList: [],
		WeighRemark: '',
		ProductLogisticsState: '',// ['待完善:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品物流状态,
		ProductLogisticsRejectReason: '',
	}
	//验仓
	private scopeStash = {
		RealStock: '',
		CheckWarehouseDate: '',
		IsHaveNewAndOldPackage: false,
		ProductCheckWarehouseState: '',//['待完善:0' or '待审核:1' or '审核通过:2' or '审核不通过:3']: 商品验仓状态,
		ProductCheckWarehouseRejectReason: '',
	}
	private formRule: any = {
		'ProductName': '请填写商品名',
		'ProductClassId': '请选择商品类目',
		// 'MinPurchase':'请输入最低起购数量',
		'CanSubmitOrderRoleGradeList': '请选择可下单人群',
		'FreightTemplateId': '请选择物流模板',
		'ProviderReturnAddressId': '请选择退货地址'
	}
	private picRule: any = {
		'ProductThumbImgUrl': '请上传封面图',
		'ImgUrl': '请上传商品主图',
		'Details': '请上传详情页',
	}
	private aptitudeRule: any = {
		// 'ProductSixFaceRealPicture': '请上传产品六面实拍图/合格证标签/吊牌正反面',
		// 'TradeMarkRegistrationCertificate': '请上传商标注册证明',
		// 'BrandLicensingLink': '请上传品牌授权链接(盖章版)',
		// 'ProductCommitmentLetter': '请上传产品承诺书',
		// 'ExaminingReport': '请上传检测报告',
		// 'ProductionEntrustCertificate': '请上传包装上的生产商资质和生产委托证明',
	}
	private logisticsRule: any = {
		'ExpressDeliveryList': '请选择发货快递',
		'PlaceOfDispatch': '请填写发货地',
		'FreightRule': '请填写偏远地区运费规则',
		'FreightSettlementTemplateId': '请选择物流结算模板',
		'PrivacyWaybillImgUrlList': '请上传隐私面单拍照',
		'PackagedVideoList': '请上传打包视频',
		'WeighImgUrlList': '请上传称重图',
	}
	private stashRule: any = {
		'RealStock': '请检查商品库存',
		// 'CheckWarehouseDate':'请选择验仓日期',
	}
	private token: any = {}
	private skus: any = [{
		name: '', // 规格名
		list: []
	}]
	private skuDetail: any = []
	private skuNames: string[] = []
	private totalSku: any = {
		Stock: '', //库存
		Price: '', //原价/市场价
		GroupPrice: '', //团购价
		ProviderSupplyPrice: '',//商家供货价
	}
	private copytotalSku: any = {
		Stock: '', //库存
		Price: '', //原价/市场价
		GroupPrice: '', //团购价
		SpreadPrice: '', //差价
		ThirdRolePrice: '', //总代价
		RouTuanPrice: '', //肉团价
		lc_price: '',//联创
		core_price: '',//核心
	}
	private showSelectRefundAddress = false;
	private selectRA: any = null;
	private isCover = false;
	private logisticsList: any = [];

	//最多添加规格数
	private specificationsNum = maxspecifications

	private searchName = ''
	private searchList: any = []
	private searchLoading = false
	private Shared = false
	private SharedDetail: any = []
	private SharedtotalSku: any = []
	private minnum = 0

	private currentUrl = ''
	private showPreview = false
	private fileType = 'image'

	private checkpassShow = false
	private checkrejectedreason = ''
	private refuseResultVal = 1
	private refuseResult = [
		{
			label: '商品信息不全',
			value: 1
		}, {
			label: '商品规格不正确',
			value: 2
		}, {
			label: '商品类型违规',
			value: 3
		}, {
			label: '其他',
			value: 4
		}
	]
	//规格排序
	private changeDrag = false

	private isButtjoint = false
	private jushuitantips = false

	private importShow = false

	private errorTipsShow = false
	private errorType = 40000001
	private gradeList: any = [
		{
			label: '联创',
			value: 1
		}, {
			label: '核心',
			value: 2
		}, {
			label: '总代',
			value: 3
		}, {
			label: '客户(含提交注册团长信息的待审核用户)',
			value: 0
		}
	]

	private delTipShow = false
	private couponShow = false
	private editoroption: any = quillconfig
	private categoryoptions: any = []

	private scheduleShow = false
	private scheduleMsg: any = {

	}
	private purchaselist: any = []
	private flowTab = 1
	private flowTablist = [
		{ value: 1, label: '物流与服务' },
		{ value: 2, label: '验仓信息确认' },
	]
	private LogisticsCompany: any = []
	private freightTemplateMsg: any = {}
	private freightTemplateShow = false
	private InspectShow = false
	private creatAddressShow = false
	private homePageImgNorm = false
	private mainImgNorm = false
	private assemblySupplyPrice = ''
	private assemblySubmenu: any = []
	private settleTemplateList: any = []
	// private logisticsTemplateShow = false
	private checkoutMsg: any = {}
	private copyText: any = {}
	private defaultImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/9d444a0d810d7945de8af64ae2cd8a9.png'
	private SettlementTemplateLoading = false


	private templates = [];
	private showPreviewMainImage = false;
	private isReady = false;

	get templateUrl() {
		if (!this.formData.ProductImgTemplateId) return;
		let url = '';
		this.templates.map(item => {
			if (item.Id === this.formData.ProductImgTemplateId) {
				url = this.url + item.TemplateWatermarkImgUrl;
			}
		})
		return url;
	}

	@Watch('formData.NoWatermarkImgUrl')
	private imgUrlChange(newd, oldd) {
		if (!this.isReady) return;
		this.formData.ImgUrl = JSON.parse(JSON.stringify(this.formData.NoWatermarkImgUrl));
		if (this.formData.NoWatermarkImgUrl.length && this.templateUrl) {
			// setTimeout(this.getCanvasImage, 500)
		}
	}
	@Watch('templateUrl')
	private templateChange(newd, oldd) {
		if (!this.isReady) return;
		if (!newd) {
			this.formData.ImgUrl[0] = this.formData.NoWatermarkImgUrl[0];
		}
		// console.log('templateChange')
		if (this.formData.NoWatermarkImgUrl.length && this.templateUrl) {
			// setTimeout(this.getCanvasImage, 500)
			// this.getCanvasImage();
		}
	}

	private async beforeMount() {

		this.initData()
	}
	private async mounted() {
		if (this.$route.query.index) {
			this.chooseTab = Number(this.$route.query.index) - 1
		}
		if (this.$route.query.flowTab) {
			this.flowTab = Number(this.$route.query.flowTab)
		}
		this.isLook = this.$route.query.type == 'look'
		await this.getproductClassfilterBoxList()//类目列表

		this.getpurchaseList()//采购人员
		this.getExpressList()//快递公司
		this.getSettleTemplate()
		await this.getImageTemplate();
		if (this.$route.query.id) {
			this.id = this.$route.query.id + ''
			this.isPageLoading = true;
			await this.getInfo();
		}else{
			this.templates.map(item=>{
				if (item.IsDefault){
					this.formData.ProductImgTemplateId = item.Id;
				}
			})
		}

		setTimeout(() => {
			this.isReady = true;
		}, 500)
	}

	private getCanvasImage() {
		return new Promise((resolve, reject)=>{
			html2canvas(document.querySelector('#canvasBox'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
				logging: false,
			}).then((canvas) => {
				let canvasUrl = canvas.toDataURL('image/png')
				axios.post( host + '/api/image/upload?PlatForm=routuan&Path=image', {Images: [canvasUrl]}).then(res => {
					let dt = res.data;
					resolve(dt.Result[0]);
				}).catch(err => {
					reject(false);
					console.log('上传失败',err);
				})
			});
		})
	}

	private handlePreviewTemplate() {
		if (!this.formData.ProductImgTemplateId) {
			this.$message.error('请选择模板');
			return;
		}
		if (!this.formData.ImgUrl.length) {
			this.$message.error('请先上传主图');
			return;
		}
		this.showPreviewMainImage = true;
	}

	private async getImageTemplate() {
		try {
			let res = await productImgTemplateList({})
			this.templates = res.Result;
		} finally {
			//
		}
	}

	private showJustSave() {
		let show = (this.$route.query.index == '1' && this.formData.ProductInfoState == 1) ||
			(this.$route.query.index == '2' && this.formData.ProductMaterialState == 1) ||
			(this.$route.query.index == '3' && this.formData.ProductAptitudeState == 1) ||
			(this.$route.query.index == '4' && this.formData.ProductLogisticsState == 1)
		return show
	}
	private showLookImg(url, type) {
		this.currentUrl = url
		this.fileType = type
		this.showPreview = true
	}
	private changeTab(e) {
		// if(e==3&&this.formData.ProductLogisticsState==2){
		// 	this.flowTab = 2
		// }else{
		this.flowTab = 1
		// }
	}
	private checkChangeShowImg(e, m, n) {
		if (!e) return
		let length = this.formData.ProductInfo.reduce((pre, cur) => {
			if (cur.IsShowOnImg) {
				pre += 1
			}
			return pre
		}, 0)
		if (length > 5) {
			this.$message.error('为了兼容简图样式最多显示5项商品信息')
			this.formData.ProductInfo[n].IsShowOnImg = false
			return
		}
	}
	private showStep(isNext) {
		let tablist = this.arrowlist.map(v => Number(v.value))
		let flowTab = this.flowTablist.map(v => Number(v.value))
		let max = Math.max(...tablist)
		let min = Math.min(...tablist)
		if (isNext) {
			return !this.$route.query.index && this.chooseTab < max
			// return this.chooseTab<max&&tablist.length>1&&this.$route.query.type!='change'&&(this.$route.query.type!='look'||(this.$route.query.type=='look'&&!this.$route.query.index))
		} else {
			return !this.$route.query.index && this.chooseTab > min
			// return this.chooseTab>min&&tablist.length>1&&this.$route.query.type!='change'&&(this.$route.query.type!='look'||(this.$route.query.type=='look'&&!this.$route.query.index))
		}
	}

	private changescroll(next) {
		let list = this.arrowlist.map(v => v.value)
		let index = list.indexOf(this.chooseTab)
		if (next) {
			this.chooseTab = list[index + 1] || list[list.length - 1]
		} else {
			this.chooseTab = list[index - 1] || list[0]
		}
		this.$nextTick(() => {
			let errdiv = document.getElementsByClassName('page-container-inside')
			errdiv[0].scrollTop = 0
		})
	}
	private downloadtemplate(name) {
		// console.log(name)
		let list = []
		if (name == 'BrandLicensingLink') {
			list = [
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('附件一品牌授权书')}.docx`,
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('身份授权')}.docx`
			]
		} else if (name == 'ProductCommitmentLetter') {
			list = [
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('附件二 A （通用类）')}.docx`,
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('附件二 C （农产品及销售方）')}.docx`
			]
		} else if (name == 'ProductionEntrustCertificate') {
			list = [
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('附件四.（生产加工委托证明）docx')}.docx`,
			]
		} else if (name == 'SupplementaryMaterial') {
			list = [
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('附件三（专利授权）docx')}.docx`,
			]
		} else if (name == 'ReplenishTemplate') {
			list = [
				`https://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/Files/${encodeURI('通用补充模板')}.docx`,
			]
		}
		for (let item of list) {
			// console.log(item)
			this.downFile(item)
		}
	}
	private downFile(file) {
		const url = file
		let iframe = document.createElement('iframe')
		iframe.id = new Date().getTime().toString()
		iframe.style.display = "none"
		document.body.appendChild(iframe)
		iframe.src = url;
	}
	private saveInfoImg() {
		this.tocopy('', false)
		this.$nextTick(() => {
			html2canvas(document.querySelector('#infoImg'), {
				useCORS: true, // 【重要】开启跨域配置
				scale: 2,
				allowTaint: true, // 允许跨域图片
				logging: false,
			}).then((canvas) => {
				let canvasUrl = canvas.toDataURL('image/png')

				var a: any = document.createElement("a");

				var event = new MouseEvent("click");

				a.download = new Date().getTime() + '.png';

				a.href = canvasUrl;

				a.dispatchEvent(event);
			});
		})
	}
	private tocopy(e, copy) {
		let text = ''
		let price = '【市场零售价格】'
		let group = '【肉团团购价格】'
		this.copyText = {
			price: '',
			group: '',
			info: []
		}
		let allprice = 0
		let allgroup = 0
		let SpecValuelist = []
		this.skuDetail.map(v => {
			if (!SpecValuelist.some(x => x.SpecValue == v.SpecValue)) {
				SpecValuelist.push({
					SpecValue: v.SpecValue,
					price: '',
					group: '',
				})
			}
			SpecValuelist = SpecValuelist.map(x => {
				if (x.SpecValue == v.SpecValue) {
					if (!x.price || v.Price < x.price) {
						x.price = v.Price
						allprice += Number(v.Price * 100)//乘100防止小数有精度丢失的问题
					}
					if (!x.group || v.GroupPrice < x.group) {
						x.group = v.GroupPrice
						allgroup += Number(v.GroupPrice * 100)
					}
				}
				return x
			})
		})
		if (allprice == SpecValuelist[0].price * SpecValuelist.length * 100) {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
					this.copyText.price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				price += '￥' + SpecValuelist[0].price
				this.copyText.price = '￥' + SpecValuelist[0].price
			}
		} else {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					price += `${'￥' + x.price}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`

					this.copyText.price += '￥' + x.price
					this.copyText.price += `/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				let list = this.skuDetail.map(v => v.Price)
				let min = Math.min(...list)
				let max = Math.max(...list)
				price += `${'￥' + min}~${'￥' + max}`
				this.copyText.price += `${'￥' + min}~${'￥' + max}`
			}
		}
		if (allgroup == SpecValuelist[0].group * SpecValuelist.length * 100) {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
					this.copyText.group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				group += '￥' + SpecValuelist[0].group
				this.copyText.group = '￥' + SpecValuelist[0].group
			}
		} else {
			if (this.formData.IsIncludedSubmitOrderInfo) {
				SpecValuelist.map((x, i) => {
					group += `${'￥' + x.group}/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`

					this.copyText.group += '￥' + x.group
					this.copyText.group += `/${x.SpecValue}${i == SpecValuelist.length - 1 ? '' : ','}`
				})
			} else {
				let list = this.skuDetail.map(v => v.GroupPrice)
				let min = Math.min(...list)
				let max = Math.max(...list)
				group += `${'￥' + min}~${'￥' + max}`
				this.copyText.group += `${'￥' + min}~${'￥' + max}`
			}
		}

		text += price + '\n'
		text += group + '\n'
		this.formData.ProductInfo.map(v => {
			text += `【${v.InfoName}】`
			text += `${v.InfoContent}\n`
			this.copyText.info.push(`【${v.InfoName}】${v.InfoContent}`)
		})
		if (!copy) return
		handleClipboard(text, e)
	}

	private async justChange() {
		if (this.testAptitude()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			let res = await productscheduleProductQualificationEdit({
				ProductInfo: form
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.toBack()
			}
		} finally {
			this.pageloading = false
		}
	}
	private async submitCheck(IsOnlySave?: boolean) {
		let checkoutMsg = JSON.parse(JSON.stringify(this.checkoutMsg))
		if ((checkoutMsg.ProductInfoState == 3 && !checkoutMsg.ProductInfoRejectReason) ||
			(checkoutMsg.ProductMaterialState == 3 && !checkoutMsg.ProductMaterialRejectReason) ||
			(checkoutMsg.ProductAptitudeState == 3 && !checkoutMsg.ProductAptitudeRejectReason) ||
			(checkoutMsg.ProductLogisticsState == 3 && !checkoutMsg.ProductLogisticsRejectReason) ||
			(checkoutMsg.ProductCheckWarehouseState == 3 && !checkoutMsg.ProductCheckWarehouseRejectReason)) {
			this.$message.error('请输入驳回原因')
			return
		}
		checkoutMsg.ProductInfoRejectReason = checkoutMsg.ProductInfoState == 3 ? checkoutMsg.ProductInfoRejectReason : ''
		checkoutMsg.ProductMaterialRejectReason = checkoutMsg.ProductMaterialState == 3 ? checkoutMsg.ProductMaterialRejectReason : ''
		checkoutMsg.ProductAptitudeRejectReason = checkoutMsg.ProductAptitudeState == 3 ? checkoutMsg.ProductAptitudeRejectReason : ''
		checkoutMsg.ProductLogisticsRejectReason = checkoutMsg.ProductLogisticsState == 3 ? checkoutMsg.ProductLogisticsRejectReason : ''
		checkoutMsg.ProductCheckWarehouseRejectReason = checkoutMsg.ProductCheckWarehouseState == 3 ? checkoutMsg.ProductCheckWarehouseRejectReason : ''
		try {
			this.pageloading = true
			let form = this.trimParams()
			let data = {
				ProductInfo: form,
				ProductId: this.$route.query.id,
				...checkoutMsg,
				IsOnlySave: IsOnlySave
			}
			let res: any = {}
			if (this.$route.query.index == '1') {
				res = await productscheduleProductInfoCheck(data)
			} else if (this.$route.query.index == '2') {
				res = await productscheduleProductMaterialCheck(data)
			} else if (this.$route.query.index == '3') {
				res = await productscheduleProductAptitudeCheck(data)
			} else if (this.$route.query.index == '4') {
				res = await productscheduleProductLogisticsCheck(data)
			} else {
				res = await productscheduleProductCheck(data)
			}
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.checkpassShow = false
				this.toBack()
			}
		} finally {
			this.pageloading = false
		}
	}
	private async confirmCheck(isSchedule) {
		if (this.testMessage()) return

		if (this.$route.query.index == '2') {
			if (this.testMaterial()) return
		}
		if (this.$route.query.index == '3') {
			if (this.testAptitude()) return
		}
		if (this.$route.query.index == '4' && this.$route.query.flowTab == '1') {
			if (this.testLogistics()) return
		}
		if (this.$route.query.index == '4' && this.$route.query.flowTab == '2') {
			if (this.testStash()) return
		}
		try {
			this.pageloading = true
			let form = this.trimParams()

			// let res = await productapplyScheduleProduct({
			// 	ProductInfo:form,
			// 	IsSubmit:isSchedule
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('操作成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private async chooseSettlementTemplate(e) {
		try {
			this.SettlementTemplateLoading = true
			let res = await freightSettlementTemplatefreightSettlementTemplateInfo({
				Id: await e,
				ProductId: this.$route.query.id
			})
			if (res.IsSuccess) {
				this.formData.FreightSettlementTemplateId = e
				this.formData.TemplateName = res.Result.TemplateName
				this.formData.FreightSettlementTemplateDetailList = res.Result.DetailList
				this.formData.FreightSettlementType = res.Result.FreightSettlementType
			}
		} finally {
			this.SettlementTemplateLoading = false
		}
	}
	private async getSettleTemplate() {
		try {
			let res = await freightSettlementTemplatefreightSettlementTemplateList({
				Skip: 0,
				Take: 9999,
			})
			if (res.IsSuccess) {
				this.settleTemplateList = res.Result

			}
		} finally {
			//
		}
	}
	private chooseExpress(e, i) {
		//剔除掉当前选择的选项 选中的时候id已经赋值了 所以find能找到当前项
		let list = this.formData.ExpressDeliveryList.filter((v, x) => {
			return i != x
		})
		if (list.find(v => v.ExpressId == e)) {
			this.formData.ExpressDeliveryList[i].ExpressId = ''
			this.$message.error('请勿选择重复发货快递')
			return
		}
		let item = this.LogisticsCompany.find(v => v.Id == e)
		if (item) {
			this.formData.ExpressDeliveryList[i].ExpressName = item.ExpressValue
		}
	}
	private setAssembly() {
		if (!this.assemblySupplyPrice) {
			this.$message.error('请设置组合商品供货价')
			return
		}
		this.formData.ProductMixInfoList = this.formData.ProductMixInfoList.map(v => {
			v.ProviderSupplyPrice = this.assemblySupplyPrice
			return v
		})
		this.skuDetail = this.skuDetail.map(v => {
			v.ProviderSupplyPrice = this.assemblySupplyPrice
			return v
		})
	}
	private confirmChangeStock(list, oldMsg, Stock) {
		//组合商品无法修改库存 所以不用管
		this.formData.RealStock = Stock
		this.skuDetail = this.skuDetail.map((v, i) => {
			v.Stock = list[i].Stock
			return v
		})
	}
	private checkInventory() {
		this.InspectShow = true
	}
	private confirmChangeFreight(form) {
		// console.log(form)
		this.formData.FreightSettlementTemplateId = form.Id
		this.formData.TemplateName = form.TemplateName
		this.formData.FreightSettlementType = form.FreightSettlementType
		this.formData.FreightSettlementTemplateDetailList = form.DetailList
		this.getSettleTemplate()
	}
	private changeFreightTemplate(id) {
		this.freightTemplateMsg = {
			Id: id,
			ProductId: this.formData.Id
		}
		this.freightTemplateShow = true
	}
	private clearExpress(e) {
		this.formData.ExpressDeliveryList.splice(e, 1)
	}
	private addExpress() {
		this.formData.ExpressDeliveryList.push({
			ExpressId: null,
			ExpressName: '',
		})
	}
	private async getExpressList() {
		try {
			let res = await getExpressList({})
			if (res.IsSuccess) {
				this.LogisticsCompany = res.Result
			}
		} finally {
			//
		}
	}
	private async getpurchaseList() {
		try {
			let res: any = await productBuyerproductBuyerPageInit({
				Skip: 0,
				Take: 999999
			})
			if (res.IsSuccess) {
				this.purchaselist = res.Result.Results
			}
		} finally {
			//
		}
	}
	private initData() {
		this.formData = {
			...this.scopeProfile,
			...this.scopeMaterial,
			...this.scopeAptitude,
			...this.scopeLogistics,
			...this.scopeStash,
		}
		this.skuNames = []
		this.skuDetail = []
	}
	private async getproductClassfilterBoxList() {
		try {
			let res = await productClasslistTree({})
			if (res.IsSuccess) {
				this.categoryoptions = res.Result.map(v => {
					if (!v.SecondProductClassDtos || !v.SecondProductClassDtos.length) {
						v.children = undefined
						return v
					} else {
						v.children = v.SecondProductClassDtos.map(x => {
							if (!x.ThirdProductClassDtos || !x.ThirdProductClassDtos.length) {
								x.children = undefined
								return x
							}
							x.children = x.ThirdProductClassDtos.length ? x.ThirdProductClassDtos : undefined
							return x
						})
						return v
					}
				})
			}
		} finally {
			//
		}
	}
	private importclose() {
		this.importShow = false
		this.skuNames = []
		this.getInfo()
	}
	private exportSpecification() {
		let url = location.origin + '/pc/product/productSpecExport?ProductId=' + this.$route.query.id
		window.open(url)
	}
	private saveDrag() {
		// console.log(this.formData.sku)
		let sortlist = this.formData.sku.map(v => v.Sort).sort((a, b) => { return a - b })
		for (let index in sortlist) {
			if (!sortlist[index]) {
				this.$message.error('请完善规格的序号值')
				return false
			}
			else if (sortlist[index] != (Number(index) + 1)) {
				this.$message.error('层级必须是从1开始的连续的序号')
				return false
			}
		}
		this.formData.sku = this.formData.sku.sort((a, b) => { return a.Sort - b.Sort })
		this.formData.sku.map((v, i) => {
			v.sku_info && v.sku_info.length && v.sku_info.map(x => {
				if (x.pic_url) {
					this.formData.SpecImgSelectLeve = i
					return
				}
			})
		})
		this.skuNames = this.formData.sku.map(v => v.sku_name)
		this.changeDrag = false
		this.bunch({})
	}
	private cancelDrag() {
		this.formData.sku = this.formData.sku.map((v, i) => {
			v.Sort = i + 1
			return v
		})
		this.changeDrag = false
	}

	private toCheck(needShowDialog) {
		//审核只能审核单个tab 所以其他的tab状态不变
		this.checkoutMsg = {
			ProductScheduleApplyState: 2,
			ProductInfoState: 2,
			ProductInfoRejectReason: '',
			ProductMaterialState: 2,
			ProductMaterialRejectReason: '',
			ProductAptitudeState: 2,
			ProductAptitudeRejectReason: '',
			ProductLogisticsState: 2,
			ProductLogisticsRejectReason: '',
			ProductCheckWarehouseState: 2,
			ProductCheckWarehouseRejectReason: '',
		}
		// for(let key in this.checkoutMsg){
		// 	this.checkoutMsg[key] = this.formData[key]
		// }
		if (this.$route.query.index == '1') {
			if (this.testMessage()) return
			// this.checkoutMsg.ProductInfoState = 2
		}
		if (this.$route.query.index == '2') {
			if (this.testMaterial()) return
			// this.checkoutMsg.ProductMaterialState = 2
		}
		if (this.$route.query.index == '3') {
			if (this.testAptitude()) return
			// this.checkoutMsg.ProductAptitudeState = 2
		}
		if (this.$route.query.index == '4' && this.$route.query.flowTab == '1') {
			if (this.testLogistics()) return
			// this.checkoutMsg.ProductLogisticsState = 2
		}
		if (this.$route.query.index == '4' && this.$route.query.flowTab == '2') {
			if (this.testStash()) return
			// this.checkoutMsg.ProductCheckWarehouseState = 2
		}
		if (!needShowDialog) return
		this.checkpassShow = true
	}


	private showSelectRefund() {
		this.showSelectRefundAddress = true;
	}

	private SharedStock(e, i) {
		if (!this.formData.IsShareStock) return
		let num = this.SharedDetail[e][i].Stock
		this.SharedDetail.map(v => {
			v.map((x, y) => {
				if (y == i) {
					x.Stock = num
				}
				return x
			})
			return v
		})
		// console.log(num.Stock)
	}
	private pushProductInfo() {
		this.formData.ProductInfo.push({
			InfoName: '',
			InfoContent: '',
			IsShowOnImg: false,
		})
		// console.log(this.formData.ProductInfo,2)
	}

	private delProductInfo(i) {
		this.formData.ProductInfo.splice(i, 1)
	}

	private changeShared(e) {
		this.formData.IsShareStock = e
		this.bunch({})
	}


	private async bunch(obj: any) {
		let arr = JSON.parse(JSON.stringify(this.formData.sku))
		// console.log(arr)
		let num = 0
		let list = []
		if (arr.length == 1) {
			arr.map(v => {
				v.sku_info.map(x => {
					list.push([x])
				})
			})
		}
		//规格只有一个的时候不会走这个循环 所以上面直接赋值就行
		for (let i = 0; i < arr.length - 1; i++) {
			if (i + 1 >= arr.length) break
			let a: any = this.combo(arr[i], arr[i + 1], i)
			// console.log(a,'a')
			//拼接完成之后将前一个数据替换掉 再与后面还没拼接的数据继续拼接
			arr.splice(i + 1, 1, { sku_info: a })
			num++
			if (num >= arr.length - 1) {
				list = a
			}
		}
		// console.log(list,'list')
		let detaillist = list.map(v => {
			let data: any = {
				ImgUrl: v.find(x => x.pic_url)?.pic_url || '',
				Id: 0,
				preorder_num: 0,
				sales_amount: 0,
				core_price: '', //核心价
				lc_price: '', //联创价
				SellCount: 0, //销量
				Price: '', //原价/市场价
				Stock: '', //库存
				GroupPrice: '', //团购价
				ThirdRolePrice: '', //总代价
				SpreadPrice: '', //差价
				RouTuanPrice: '', //肉团价
				Count: '',
				IsCanSubmitOrder: true,
				ProductSpecNo: '',
				ProviderSupplyPrice: '',//商家供货价
			}
			v.map((x, i) => {
				let key = 'SpecValue' + (i == 0 ? '' : i + 1)
				data[key] = x.sku_value
				data.classKey = ''
				data.classKey += x.classKey
				//只有一个规格会有数据
				if (this.formData.IsShareStock && i == 0) {
					data.Count = x.Count
					data.IsCanSubmitOrder = x.IsCanSubmitOrder
				}
			})
			// console.log(data)
			return data
		})
		//如果是计入交单信息 把没有计入交单信息的数据的批量设置清空 
		//在getshardlist()里统一对所有数据为0的数据批量赋值 如果没有清空则不存在所有数据为0的
		if (this.formData.IsIncludedSubmitOrderInfo) {
			this.totalSku = {
				Stock: '', //库存
				Price: '', //原价/市场价
				GroupPrice: '', //团购价
				SpreadPrice: '', //差价
				ThirdRolePrice: '', //总代价
				RouTuanPrice: '', //肉团价
				lc_price: '',//联创
				core_price: '',//核心
				ProviderSupplyPrice: '',//商家供货价
			}
		} else {
			//两个数据一样的 如果清空了 再取回来
			this.totalSku = this.copytotalSku
		}
		// console.log(detaillist)
		if (obj.changetype == 1) {
			this.skuDetail = await this.oldlistChangetitle(obj, detaillist)
		} else {
			this.skuDetail = await this.assignment(detaillist, obj)
		}

		//计入交单信息
		if (this.formData.IsIncludedSubmitOrderInfo) {
			let SharedDetail: any = []
			SharedDetail = await this.getshardlist(this.skuDetail, obj)
			this.SharedDetail = SharedDetail
		}
		// console.log(this.skuDetail)
		// console.log(this.SharedDetail.map(v=>v.map(x=>x.isShowNumInput)),111)
	}
	//如果设置了共享库存 则需要改变商品详情的数组结构
	private getshardlist(list: any, obj: any) {
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		let minnum = Math.min(...sku[0].sku_info.map(v => v.Count || 0))
		this.minnum = minnum
		let newlist: any = []
		sku[0].sku_info.map((v, i) => {
			let data: any = []
			list.map(x => {
				if (x.SpecValue == v.sku_value) {
					// console.log(v)
					x.Count = v.Count
					x.IsCanSubmitOrder = v.IsCanSubmitOrder || false
					x.isShowNumInput = (minnum != 0 && minnum == v.Count)
					// console.log(x)
					//看bunch()批量设置清空
					if (!x.Stock && !x.Price && !x.GroupPrice && !x.SpreadPrice && !x.ThirdRolePrice && !x.RouTuanPrice) {
						for (let key in this.SharedtotalSku[i]) {
							let xkey = key.substring(9, key.length)
							x[xkey] = this.SharedtotalSku[i][key]
							if (key == 'SpecBacthSecondRolePrice') {
								x.core_price = this.SharedtotalSku[i]['SpecBacthSecondRolePrice']
							} else if (key == 'SpecBacthFirstRolePrice') {
								x.lc_price = this.SharedtotalSku[i]['SpecBacthFirstRolePrice']
							}
						}
						// x.RouTuanPrice = parseFloat((x.SpreadPrice - x.SpreadPrice).toFixed(2))
					}
					data.push(x)
				}
			})
			if (!this.SharedtotalSku[i]) {
				let batch: any = {
					SpecBacthStock: '', //库存
					SpecBacthSellCount: '',//数量
					SpecBacthPrice: '', //原价/市场价
					SpecBacthGroupPrice: '', //团购价
					SpecBacthSpreadPrice: '', //差价
					SpecBacthThirdRolePrice: '', //总代价
					SpecBacthRouTuanPrice: '', //肉团价
					SpecBacthProviderSupplyPrice: '',//商家供货价
				}
				this.SharedtotalSku.push(batch)
			}
			newlist.push(data)
		})

		return newlist
	}
	//如果是修改规格名称 则不会改变表格内的数量 所以按顺序赋一遍值就行了
	private oldlistChangetitle(obj: any, list: any) {
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		return list.map((v, i) => {
			for (let key in v) {
				// console.log(key)
				//除了规格型号的值 全替换成原来的数据
				if (key.indexOf('SpecValue') == -1) {
					v[key] = oldlist[i][key]
				}
			}
			return v
		})
	}
	//每次传入两个数组互相拼接
	private combo(arr1: any, arr2: any, num: number) {
		let newarr = []
		arr1.sku_info.map(v => {
			arr2.sku_info.map(x => {
				if (num == 0) {//第一次的时候v是个字符串
					newarr.push([v, x])
				} else {//第一次之后就是一个字符串数组
					newarr.push([...v, x])
				}

			})
		})
		return newarr
	}

	private assignment(detaillist: any, msg: any) {
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		let list: any = []
		detaillist.map(async (j: any, ind: number) => {
			// console.log(this.findoldVal(detaillist,j),ind)
			let obj = await this.findoldVal(detaillist, j)
			// console.log(obj,'obj',j,'j')
			//如果在原数据中没有找到老的数据 对象为空
			//因为新增的数据跟老数据没有太大差别 在下一次新增时 上一个新增的会成为老数据 所以不用id判断
			//删除的时候也直重新算新数据
			if (Object.keys(obj).length == 0 || msg.IsDel) {
				let ThirdRolePrice = this.totalSku.ThirdRolePrice //总代价
				let SpreadPrice = this.totalSku.SpreadPrice //差价
				let core_price = this.totalSku.core_price //核心价
				let lc_price = this.totalSku.lc_price //联创价
				let ProviderSupplyPrice = this.totalSku.ProviderSupplyPrice //商家供货价
				let oldmsg = this.getpicurl(j)
				// console.log(oldmsg,'oldmsg')
				let data: any = {
					ImgUrl: j.ImgUrl,
					Id: 0,
					preorder_num: 0,
					sales_amount: 0,
					core_price: core_price, //核心价
					lc_price: lc_price, //联创价
					SellCount: 0, //销量
					Price: this.totalSku.Price, //原价/市场价
					Stock: this.totalSku.Stock, //库存
					GroupPrice: this.totalSku.GroupPrice, //团购价
					ThirdRolePrice: this.totalSku.ThirdRolePrice, //总代价
					SpreadPrice: this.totalSku.SpreadPrice || '', //差价
					// RouTuanPrice:this.totalSku.RouTuanPrice, //肉团价  列表上这一列注释了，这里新增就不赋值了，不然老数据有问题
					Count: j.Count,
					IsCanSubmitOrder: j.IsCanSubmitOrder,

					ProviderSupplyPrice: this.totalSku.ProviderSupplyPrice || '',//商家供货价
				}
				sku.map((v, i) => {
					let key = 'SpecValue' + (i == 0 ? '' : i + 1)
					data[key] = j[key]
				})
				// console.log(this.totalSku)
				// console.log(data,'data')
				list.push(data)
			} else {
				obj.ImgUrl = j.ImgUrl
				obj.Count = j.Count
				obj.IsCanSubmitOrder = j.IsCanSubmitOrder
				// console.log(obj,j,'else')
				list.push(obj)
			}
		})

		return list
	}
	//新增型号的时候会有没有改变的数据
	private findoldVal(newlist: any, newval: any) {
		let oldlist = JSON.parse(JSON.stringify(this.skuDetail))
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		// console.log(this.formData.sku,123)
		let oldvalue: any = {}
		old: for (let i = 0; i < oldlist.length; i++) {
			let num = 0
			sku: for (let x = 0; x < sku.length; x++) {
				let key = 'SpecValue' + (x == 0 ? '' : x + 1)
				// console.log(key)
				if (oldlist[i][key] === newval[key]) {
					num += 1
					continue sku
				}
			}
			if (num == sku.length) {
				oldvalue = oldlist[i]
				break old
			}
		}
		return oldvalue
	}
	//这里找到对应数据对应的规格信息 查找图片
	private getpicurl(newval: any) {
		// console.log(newval)
		let sku = JSON.parse(JSON.stringify(this.formData.sku))
		let list: any = []
		for (let i = 0; i < sku.length; i++) {
			for (let y = 0; y < sku[i].sku_info.length; y++) {
				let key = 'SpecValue' + (i == 0 ? '' : i + 1)
				if (newval[key] === sku[i].sku_info[y].sku_value) {
					list.push(sku[i].sku_info[y])
					break
				}
			}
		}
		return list
	}


	private clearSearch() {
		this.searchName = ''
		this.searchShop('')
	}

	private getIsIncludedSubmitOrderInfo(val) {
		this.formData.IsIncludedSubmitOrderInfo = val
		this.bunch({})
	}

	private calculateinventory(row) {
		// Stock 
		let two = /^\d+(\.\d{1,2})?$/
		if (row.ProductCount < 1 || row.ProductCount > 999 || !two.test(row.ProductCount)) {
			this.$message.error('只能填写1~999的整数')
			return
		}
		if (this.formData.ProductMixInfoList.every(v => v.ProductCount >= 1 && v.ProductCount <= 999)) {
			this.getstock()
		}
	}

	private getstock() {
		this.skuDetail[0].Stock = Math.min(...this.formData.ProductMixInfoList.map(v => Math.floor(v.Stock / v.ProductCount)))
		// console.log(this.formData.ProductMixInfoList)
	}

	private delcombination(row) {
		this.formData.ProductMixInfoList = this.formData.ProductMixInfoList.filter(v => {
			return row.ProductId != v.ProductId
		})
		if (!this.formData.ProductMixInfoList.length) {
			this.skuDetail = []
		} else {
			if (this.formData.ProductMixInfoList.every(v => v.ProductCount >= 1 && v.ProductCount <= 999)) {
				this.getstock()
			}
		}
	}

	private changeProductType() {
		this.formData.sku = []//规格参数
		this.skuDetail = []//设置价格那个详细表格数据
		this.searchName = ''//组合商品选中的Id
		this.searchList = []//组合商品查询的列表
		this.formData.ProductMixInfoList = []//组合商品的详细列表
		this.totalSku = {//批量修改的参数
			Stock: '', //库存
			Price: '', //原价/市场价
			GroupPrice: '', //团购价
			SpreadPrice: '', //差价
			ThirdRolePrice: '', //总代价
			RouTuanPrice: '', //肉团价
			lc_price: '',//联创
			core_price: '',//核心
		}
		this.formData.SpecImgSelectLeve = ''
		this.SharedDetail = []
		this.SharedtotalSku = []
		this.formData.IsShareStock = false
		this.formData.IsIncludedSubmitOrderInfo = false
		for (let i = 0; i < this.specificationsNum; i++) {
			let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
			this.formData[key] = '';
		}
	}
	private searchDetail(Id) {
		return new Promise(async (res, rej) => {
			try {
				let result = await productproductProviderSupplyPrice({
					ProductId: Id
				})
				if (result.IsSuccess) {
					res(result.Result)
				} else {
					rej()
				}
			} catch {
				rej()
			} finally {
				//
			}
		})
	}
	private async pushProduct() {
		// console.log(this.searchName)
		try {
			if (this.isLook) {
				return
			}
			if (!this.searchName) {
				this.$message.error('请选择商品')
				return
			}
			let detail: any = await this.searchDetail(this.searchName)
			let skuNames: any = []
			for (let i = 0; i < this.specificationsNum; i++) {
				let key = 'SpecTitle' + (i == 0 ? '' : (i + 1))
				if (detail[key]) {
					skuNames.push(detail[key])
				}
			}
			this.formData.ProductMixInfoList.push({
				...this.searchList.find(v => v.ProductId == this.searchName),
				ProductCount: '',
				skuNames: skuNames,
				ProductSpecList: detail.ProductSpecList,
				ProviderSupplyPrice: '',
			})
			//aaaaaaaa
			// console.log(skuNames,detail.ProductSpecList,this.formData.ProductMixInfoList)


			this.searchList = this.searchList.filter(v => {
				return !this.formData.ProductMixInfoList.some(x => v.ProductId == x.ProductId)
			})
			this.skuNames = ['规格']
			if (!this.skuDetail.length) {
				this.skuDetail = [{
					Id: 0,
					SpecValue: '组合商品',
					SpecValue2: '',
					SpecValue3: '',
					ImgUrl: '',
					SellCount: '',
					Stock: '',
					Price: '',
					GroupPrice: '',
					SpreadPrice: '',
					ThirdRolePrice: '',
					RouTuanPrice: '',
					core_price: '',
					lc_price: '',
					ProviderSupplyPrice: '',
				}]
			}
			// console.log(this.formData.ProductMixInfoList)
			this.skuDetail[0].Stock = this.formData.ProductMixInfoList.reduce((pre, cur) => {
				return pre += Number(cur.Stock)
			}, 0)
			this.computedStock()
			this.searchName = ''
			this.searchShop('')
		} finally {
			//
		}
	}

	private async searchShop(e) {
		try {
			this.searchLoading = true
			let data = {
				Skip: 0,
				Take: 999999,
				Keywords: await e,
				ProductType: 0,
				ProviderId: this.formData.ProviderId
			}
			let res: any = await productList(data)
			if (res.IsSuccess) {
				this.searchList = res.Result.Results.map(v => {
					v.ProductId = v.Id
					v.Id = 0
					return v
				}).filter(v => {
					return !this.formData.ProductMixInfoList.some(x => v.ProductId == x.ProductId)
				})
				// console.log(this.searchList)
				this.searchName = ''
			}
		} finally {
			this.searchLoading = false
		}
	}

	private validateNumber(e) {
		e.target.value = e.target.value.replace(/[^\d.]/g, '')
		e.target.value = e.target.value.replace(/\.{2,}/g, '.')
		e.target.value = e.target.value.replace(/^\./g, '0.')
		e.target.value = e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0, e.target.value.length -
			1))
		e.target.value = e.target.value.replace(/^0[^\.]+/g, '0')
		e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
		return e.target.value
	}

	private toBack() {
		this.$router.go(-1)
	}

	private toLogistics() {
		this.$router.push({
			name: 'Template_Detail'
		})
	}
	private toLogistics2() {
		this.$router.push({
			path: 'settleFreight',
			query: {
				Id: this.$route.query.id,
				// ProviderId:row.ProviderId,
				Name: encodeURIComponent(this.formData.ProductName),
				Img: encodeURIComponent(this.formData.ImgUrlComplete[0]),
			}
		})
	}
	private changeroutuan(e, i) {
		//lc_price
		if (this.skuDetail[i].RouTuanPrice > this.skuDetail[i].lc_price) {
			this.skuDetail[i].RouTuanPrice = ''
			this.$message.error('公司拿货价需低于级别拿货价')
			return
		}
	}

	private testMessage() {
		for (let key in this.formRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				this.$message({
					type: 'error',
					message: this.formRule[key]
				})
				return true
			}
		}
		if (!this.skuDetail || !this.skuDetail.length) {
			this.$message.error('请设置商品规格')
			return true
		}
		if (this.formData.ProductType == 1) {
			for (let item of this.formData.ProductMixInfoList) {
				if (!item.ProductCount) {
					this.$message.error('请设置组合内数量')
					return true
				}
			}
		}
		if (this.formData.ProductType == 1 && this.formData.SettlementType == 0 && !this.assemblySupplyPrice) {
			this.$message.error('请设置组合商品供货价')
			return true
		}
		if (this.formData.IsShareStock) {
			for (let item of this.formData.sku[0].sku_info) {
				if (item.Count < 1 || item.Count > 9999 || item.Count != parseInt(item.Count)) {
					this.$message({
						type: 'warning',
						message: '请输入正确的数量'
					})
					return true
				}
			}
		}
		let list = [
			{ key: 'Price', label: '原价/市场价不可小于0' },
			{ key: 'GroupPrice', label: '团购价不可小于0' },
			{ key: 'ProviderSupplyPrice', label: '商家供货价不可小于0' },
		]
		//不计入交单
		if (!this.formData.IsIncludedSubmitOrderInfo) {
			for (let item of this.skuDetail) {
				for (let ele of list) {
					item[ele.key] = Number(item[ele.key])
					if (parseInt(item[ele.key]) < 0 || item[ele.key] === '') {
						this.$message.error(ele.label)
						return true
					}
				}
			}
		} else {
			for (let item of this.SharedDetail) {
				for (let item2 of item) {
					for (let ele of list) {
						item2[ele.key] = Number(item2[ele.key])
						if (parseInt(item2[ele.key]) < 0 || item2[ele.key] === '') {
							this.$message.error(ele.label)
							return true
						}

					}
				}
			}

		}
		return false
	}
	private testMaterial() {
		for (let key in this.picRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				this.$message({
					type: 'error',
					message: this.picRule[key]
				})
				return true
			}
		}
		return false
	}
	private testAptitude() {
		for (let key in this.aptitudeRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				console.log(this.formData[key], key)
				this.$message({
					type: 'error',
					message: this.aptitudeRule[key]
				})
				return true
			}
		}
		return false
	}
	private testLogistics() {
		for (let key in this.logisticsRule) {
			if (key == 'ExpressDeliveryList' && (!this.formData[key] || !this.formData[key].length || !this.formData[key].filter(v => v.ExpressId).length)) {
				this.$message({
					type: 'error',
					message: this.logisticsRule[key]
				})
				return true
			}
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				console.log(this.formData[key], key)
				this.$message({
					type: 'error',
					message: this.logisticsRule[key]
				})
				return true
			}
		}
		return false
	}
	private testStash() {
		for (let key in this.stashRule) {
			if (!String(this.formData[key]) || (Array.isArray(this.formData[key]) && !this.formData[key].length)) {
				console.log(this.formData[key], key)
				this.$message({
					type: 'error',
					message: this.stashRule[key]
				})
				return true
			}
		}
		return false
	}
	// 数据是否为空
	private isEmpty() {
		return false;
	}

	/**
	 * 添加规格
	 */
	private addSkus() {
		if (this.isLook) {

			return
		}
		if (this.formData.sku.length >= this.specificationsNum) {
			let list = ['一', '二', '三', '四', '五']
			this.$message(`最多添加${this.specificationsNum}个规格`);
			return false
		}
		this.formData.sku.push({
			sku_name: '',
			sku_info: [],
			Sort: this.formData.sku.length + 1,
		})
		this.isCover = true;
	}

	/**
	 * 删除规格
	 */
	private deleteSkus(obj: any) {
		this.formData.sku.splice(obj.index, 1);
		this.calcSku(obj)
		// this.formData.SpecImgSelectLeve = obj.picIndex;
		// console.log(this.formData.sku)
		this.bunch({ IsDel: true })
	}

	/**
	 * 计算生成sku
	 */
	private calcSku(obj: any) {
		if (obj.type && obj.type === 'delete') {
			this.isCover = true;
		}
		// console.log(obj,11)
		this.formData.SpecImgSelectLeve = obj.picIndex;
		// console.log(obj)
		const list = obj.list;
		const skuList: any = [];
		const skuName: string[] = [];
		let tableListLength = 1
		let skuItem = {}
		this.formData.sku = [];
		list.length && list.map((item: any, index: number) => {
			if (item.sku_name) {
				skuName.push(item.sku_name);
			}
		})
		this.formData.sku = list;
		// console.log(list)
		this.skuNames = skuName;
		this.bunch(obj)
	}


	// 获取token
	private async getToken() {
		try {
			const res: any = await getOssToken({})
			this.token = {
				AccessKeySecret: res.access_key_secret,
				OSSAccessKeyId: res.access_key_id,
				SecurityToken: res.security_token
			}
		} catch (e) {
			console.error('getOssToken ===>', e)
		}
	}

	// 改变全部价格
	private changAllPricd2(e: any, oldtype: string, v: any, i: any) {
		let two = /^\d+(\.\d{1,2})?$/
		let type = oldtype
		let batchtype = 'SpecBacth' + type
		// console.log(type)
		//联创 核心字段跟接口不一样 转换一下
		let typeinfo = {
			'SecondRolePrice': 'core_price',
			'FirstRolePrice': 'lc_price'
		}
		type = typeinfo[oldtype] || oldtype
		this.SharedDetail = this.SharedDetail.map((val, ind) => {
			if (ind == i) {
				for (let item of val) {
					item[type] = this.SharedtotalSku[i][batchtype];
					let oldpri = JSON.parse(JSON.stringify(item[type]))
					// console.log(item[type],this.SharedtotalSku[i][batchtype])
					if (type === 'core_price' || type === 'lc_price') {
						// 	let core_price = parseFloat(((item.ThirdRolePrice || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// console.log(core_price, 666)
						// 	// if (core_price < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('核心价不可小于0')
						// 	// 	break
						// 	// }
						// 	let lc_price = parseFloat(((core_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// if (lc_price < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('联创价不可小于0')
						// 	// 	break
						// 	// }
						// 	let RouTuanPrice = parseFloat(((lc_price || 0) - (item.SpreadPrice || 0)).toFixed(2));
						// 	// if (RouTuanPrice < 0) {
						// 	// 	item[type] = oldpri
						// 	// 	this.SharedtotalSku[i][batchtype] = ''
						// 	// 	this.$message.error('肉团价不可小于0')
						// 	// 	break
						// 	// }
						let SpreadPrice = parseFloat(((item.core_price || 0) - (item.lc_price || 0)).toFixed(2));
						if (SpreadPrice < 0) {
							item[type] = oldpri
							this.SharedtotalSku[i][batchtype] = ''
							this.$message.error('差价不可小于0')
							break
						}

						item.SpreadPrice = SpreadPrice
						// 	item.core_price = core_price
						// 	item.lc_price = lc_price
						// 	item.RouTuanPrice = RouTuanPrice
					}
				}
				// console.log(this.SharedDetail[i])
			}
			if (type == 'Stock') {
				this.SharedtotalSku = this.SharedtotalSku.map(v => {
					v[batchtype] = this.formData.IsShareStock ? this.SharedtotalSku[i][batchtype] : v[batchtype]
					return v
				})
				for (let item of val) {
					if (!this.formData.IsShareStock) break
					item[type] = this.SharedtotalSku[i][batchtype];
					// this.formData.RealStock += Number(item[type])
				}
				this.computedStock()
			}
			return val
		})

		if (type === 'RouTuanPrice') {
			let isConform = false
			for (let list of this.SharedDetail) {
				for (let item of list) {
					if (item.lc_price < item.RouTuanPrice) {
						isConform = true
						break
					}
				}
			}
			if (isConform) {
				this.$message.error('公司拿货价需低于级别拿货价')
				this.SharedtotalSku[i][type] = ''
				this.SharedDetail = this.SharedDetail.map((v: any) => {
					v.map(x => {
						x.RouTuanPrice = ''
						return x
					})
					return v
				})
			}
		}
		if (type === 'preorder_num') {
			// this.changePreorderNum2();
		}
	}
	// 修改预售数量时 计算总数
	private changePreorderNum2() {
		this.formData.preorder_num = 0;
		this.skuDetail.map((item: any) => {
			this.formData.preorder_num += (+item.preorder_num || 0)
		})
	}
	private computedStock() {
		if (this.formData.IsIncludedSubmitOrderInfo) {
			this.formData.RealStock = this.SharedDetail.reduce((pre, cur) => {
				return pre += Number(cur.reduce((p, c) => {
					return p += Number(c.Stock)
				}, 0))
			}, 0)
		} else {
			if (this.formData.ProductType == 1) {
				this.formData.RealStock = Math.min(...this.skuDetail.map(v => {
					return Math.floor(v.Stock / v.ProductCount)
				}))
			} else {
				let list: any = []
				if (this.formData.IsShareStock) {
					list = this.skuDetail.filter(v => v.Count == 1 && v.SpecValue == this.skuDetail[0].SpecValue)
				} else {
					list = this.skuDetail
				}
				this.formData.RealStock = list.reduce((pre, cur) => {
					return pre += Number(cur.Stock)
				}, 0)
			}
		}
	}
	// 改变全部价格
	private changAllPricd(e: any, type: string) {
		let two = /^\d+(\.\d{1,2})?$/
		this.formData.RealStock = 0
		for (let item of this.skuDetail) {

			let oldpri = JSON.parse(JSON.stringify(item[type]))
			item[type] = this.totalSku[type] || '';
			if (type === 'Stock') {
				this.formData.RealStock += Number(item[type])
			}
			if ((type === 'core_price' || type === 'lc_price')) {


				let SpreadPrice = parseFloat(((item.core_price || 0) - (item.lc_price || 0)).toFixed(2));
				if (SpreadPrice < 0) {
					item[type] = oldpri
					this.totalSku[type] = ''
					this.$message.error('差价不可小于0')
					break
				}
				// console.log(this.totalSku[type])
				item.SpreadPrice = SpreadPrice
			}

		}
		this.computedStock()
		// console.log(this.skuDetail)
		// if(havereturn) return
		if (type === 'RouTuanPrice') {
			let isConform = false
			for (let item of this.skuDetail) {
				if (item.lc_price < item.RouTuanPrice) {
					isConform = true
					break
				}
			}
			if (isConform) {
				this.$message.error('公司拿货价需低于级别拿货价')
				this.totalSku[type] = ''
				this.skuDetail = this.skuDetail.map((v: any) => {
					v.RouTuanPrice = ''
					return v
				})
			}
		}
		if (type === 'preorder_num') {
			this.changePreorderNum();
		}
	}

	// 控制商品预购开关
	private changePreorder(e) {
		if (e) return
		// 当关闭开关直接清空设置的预售总数量
		this.formData.preorder_num = 0
		this.skuDetail.map((item: any) => {
			item.preorder_num = 0
		})
	}

	// 修改预售数量时 计算总数
	private changePreorderNum() {
		this.formData.preorder_num = 0;
		this.skuDetail.map((item: any) => {
			this.formData.preorder_num += (+item.preorder_num || 0)
		})
	}
	private wathhxlc2(e: any, index: number, i: number) {
		// console.log(i,index)
		let data: any = this.SharedDetail[i].map((v, ind) => {
			if (index == ind) {
				// console.log(v.core_price,v.lc_price)
				v.SpreadPrice = parseFloat(((v.core_price || 0) - (v.lc_price || 0)).toFixed(2));
			}
			return v
		})
		if (data.SpreadPrice < 0) {
			this.$message.error('差价不可小于0')
			data.SpreadPrice = ''
		}
		this.$set(this.SharedDetail, i, data);
	}
	// 改变核心联创的价格
	private wathhxlc(e: any, index: number) {
		let data: any = this.skuDetail[index]

		data.SpreadPrice = parseFloat(((data.core_price || 0) - (data.lc_price || 0)).toFixed(2));

		if (data.SpreadPrice < 0) {
			this.$message.error('差价不可小于0')
			data.SpreadPrice = ''
		}
		this.$set(this.skuDetail, index, data);
	}

	// 获取最大的discount
	private getMaxDiscount() {
		let maxDiscount = 0
		this.formData.sku_params.map((detail: any) => {
			let discount = detail.discount
			if (maxDiscount < discount) {
				maxDiscount = discount
			}
		})
		return maxDiscount
	}

	private trimParams() {

		this.formData.sku_params = JSON.parse(JSON.stringify(this.skuDetail.map((v, i) => {
			v.Sort = i
			return v
		})))
		let params: any = JSON.parse(JSON.stringify(this.formData));
		params.Id = this.id || '';

		params.ProductClassId = params.ProductClassId.length ? params.ProductClassId[params.ProductClassId.length - 1] : ''

		params.ProductSpecList = this.skuDetail.map(v => {
			// console.log(v.lc_price,v.core_price,'456')
			v.FirstRolePrice = v.lc_price
			v.SecondRolePrice = v.core_price
			return v
		})
		// console.log(params.ProductSpecList)
		if (params.IsIncludedSubmitOrderInfo) {
			params.ProductSpecList = []
			this.SharedDetail.map(v => {
				v.map(x => {
					params.ProductSpecList.push(x)
				})
			})
		} else {
			params.ProductSpecList = this.skuDetail.map(v => {
				if (params.ProductType == 1) {
					v.Stock = 0
				}
				return v
			})
		}
		//获取图片index
		params.sku.map((v, i) => {
			v.sku_info && v.sku_info.length && v.sku_info.map(x => {
				if (x.pic_url) {
					// console.log(x,i)
					params.SpecImgSelectLeve = i
					return
				}
			})
		})
		// console.log(params.ProductSpecList,2222)
		if (params.ProductType == 0) {
			params.ProductMixInfoList = []
			for (let i = 0; i < this.specificationsNum; i++) {
				let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
				params[key] = this.formData.sku[i] ? this.formData.sku[i].sku_name : '';
			}
			params.SpecBacthDataList = this.SharedtotalSku
		} else if (params.ProductType == 1) {
			params.SpecTitle = '规格'
			params.IsIncludedSubmitOrderInfo = false
		}

		params.SpecBacthStock = this.totalSku.Stock; //库存
		// params.SpecBacthSellCount = this.totalSku.Stock;//销量
		params.SpecBacthPrice = this.totalSku.Price; //原价/市场价
		params.SpecBacthGroupPrice = this.totalSku.GroupPrice; //团购价
		params.SpecBacthSpreadPrice = this.totalSku.SpreadPrice; //差价
		params.SpecBacthThirdRolePrice = this.totalSku.ThirdRolePrice; //总代价
		params.SpecBacthRouTuanPrice = this.totalSku.RouTuanPrice; //肉团价
		params.SpecBacthFirstRolePrice = this.totalSku.lc_price; //联创
		params.SpecBacthSecondRolePrice = this.totalSku.core_price; //核心
		params.SpecBacthProviderSupplyPrice = this.totalSku.ProviderSupplyPrice; //商家供货价

		params.ProductThumbImgUrl = params.ProductThumbImgUrl.length ? params.ProductThumbImgUrl[0] : ''
		params.Video = params.Video.length ? params.Video[0] : '';

		params.ExpressDeliveryList = params.ExpressDeliveryList.filter(v => v.ExpressId)


		params.Id = this.$route.query.type == 'copy' ? 0 : params.Id
		// console.log(params)
		return params;
	}

	/**
	 * 商品标签设置
	 */
	private handleCloseTag(index) {
		this.formData.ProductTags.splice(index, 1);
	}

	private showInput() {
		this.inputVisible = true;
		let nextTick: any = this.$nextTick;
		nextTick((obj: any) => {
			let refs: any = this.$refs;
			refs.saveTagInput.$refs.input.focus();
		});
	}

	private handleInputConfirm() {
		let inputValue = this.inputValue;
		if (inputValue) {
			this.formData.ProductTags.push(inputValue);
		}
		this.inputVisible = false;
		this.inputValue = '';
	}

	// 提交信息
	private submit(needShowType?: Number) {
		// needShowType 需要依次校验弹窗 弹窗确定的按钮传下一个校验类型
		let num = needShowType
		if (this.isButtjoint) {
			if (num == 1) {
				this.jushuitantips = true
				return
			}
		} else {
			if (num == 1) {
				num = 2
			}
		}
		if (Number(this.$route.query.index) > 0 || this.$route.query.type == 'change') {
			if (this.$route.query.index == '1') {
				this.saveMessage()
			} else if (this.$route.query.index == '2') {
				this.saveMaterial()
			} else if (this.$route.query.index == '3') {
				this.saveAptitude()
			} else if (this.$route.query.index == '4' && this.$route.query.flowTab == '1') {
				this.saveLogistics()
			} else if (this.$route.query.index == '4' && this.$route.query.flowTab == '2') {
				this.saveStash()
			}
		} else {
			this.confirmCheck(false)
		}
		// this.doCreate()
		// this.showMessage = true;
	}
	private async saveStash() {
		if (this.testStash()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			// let res:any = await productscheduleProductCheckWarehouseEdit({
			// 	ProductInfo:form,
			// 	IsSubmit:false,
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('保存成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private async saveLogistics() {
		if (this.testLogistics()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			// let res:any = await productscheduleProductLogisticsServiceEdit({
			// 	ProductInfo:form,
			// 	IsSubmit:false,
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('保存成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private async saveAptitude() {
		if (this.testAptitude()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			// let res:any = await productscheduleProductQualificationEdit({
			// 	ProductInfo:form,
			// 	IsSubmit:false,
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('保存成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private async saveMaterial() {
		if (this.testMaterial()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			// let res:any = await productscheduleProductMaterialEdit({
			// 	ProductInfo:form,
			// 	IsSubmit:false,
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('保存成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private async saveMessage() {
		if (this.testMessage()) return
		try {
			this.pageloading = true
			let form = this.trimParams()
			// let res:any = await productscheduleProductInfoEdit({
			// 	ProductInfo:form,
			// 	IsSubmit:false,
			// })
			// if(res.IsSuccess){
			// 	this.$message.success('保存成功')
			// 	this.toBack()
			// }
		} finally {
			this.pageloading = false
		}
	}
	private handleConfirm() {
		this.doCreate()
	}

	// 创建商品
	private async doCreate() {
		let params = this.trimParams();
		try {

			if (this.formData.NoWatermarkImgUrl.length && this.templateUrl) {
				// setTimeout(this.getCanvasImage, 500)
				const url = await this.getCanvasImage();
				params.ImgUrl[0] = url;
			}

			let res = await createProduct({
				ProductInfo: params,
				IsProviderCheckEdit: this.$route.query.identity == 'supplier',
				noError: true
			})
			if (res.IsSuccess) {
				this.$message({
					type: 'success',
					message: '操作成功'
				})
				this.toBack()
				// console.log(res)
			} else {
				if (res.ErrorCode == 40000001 || res.ErrorCode == 40000002) {
					this.errorTipsShow = true
					this.errorType = res.ErrorCode
				} else if (res.ErrorCode == 40000003) {
					this.delTipShow = true
				} else {
					this.$message.error(res.Message)
				}
			}
		} catch (e) {
			//
		}
	}


	private async getInfo() {
		try {
			// console.log(1)
			const res: any = await productscheduleProductDetail({
				Id: this.id
			})
			this.isPageLoading = false;
			const skuMap = {};
			// this.skus = []
			this.formData.sku = [];
			this.skuNames = []

			//计算规格类型列表
			for (let i = 0; i < this.specificationsNum; i++) {
				let key = 'SpecTitle' + (i == 0 ? '' : i + 1)
				if (res.Result[key]) {
					this.formData.sku.push({
						sku_name: res.Result[key],
						sku_info: [],
						key: Math.random(),
						Sort: i + 1,
					})
					this.skuNames.push(res.Result[key])
				}
			}

			if (res.Result.ProductImgTemplateId) {
				let list = this.templates.filter(item => {
					return item.Id === res.Result.ProductImgTemplateId;
				})
				if (!list.length) {
					res.Result.ProductImgTemplateId = null;
				}
			} else{
				res.Result.ProductImgTemplateId =  null;
			}
			if (res.Result.ProductImgTemplateId === 0){
				res.Result.ProductImgTemplateId =  null;
			}

			if (!res.Result.ProductImgTemplateId && res.Result.NoWatermarkImgUrl?.length){
				res.Result.ImgUrl = res.Result.NoWatermarkImgUrl;
			}

			if (!res.Result.NoWatermarkImgUrl?.length) {
				res.Result.NoWatermarkImgUrl = res.Result.ImgUrl;
			}

			if (res.Result.ProductSpecList && res.Result.ProductSpecList.length) {
				res.Result.ProductSpecList.forEach((item: any, index: number) => {

					if (this.$route.query.type == 'copy') {
						item.Id = 0;
					}

					item.core_price = item.SecondRolePrice
					item.lc_price = item.FirstRolePrice
					//肉团价可修改 所以初始化时不计算
					// item.RouTuanPrice = parseFloat(((item.lc_price||0) - (item.SpreadPrice||0)).toFixed(2));

					//计算规格型号列表

					for (let i = 0; i < this.specificationsNum; i++) {
						let key = 'SpecValue' + (i == 0 ? '' : i + 1)
						if (item[key] && this.formData.sku[i]) {
							var have = null;
							let haveIndex = -1;
							this.formData.sku[i].sku_info.map((obj: any, index: number) => {
								if (obj.sku_value === item[key]) {
									have = obj;
									haveIndex = index;
								}
							})
							// console.log(item,i,res.Result.SpecImgSelectLeve)
							if (!have) {
								let data = {
									pic_url: '',
									sku_value: item[key],
									sku_id: item.Id,
									sku_ids: [item.Id],
									isNew: false,
									classKey: Math.random(),
									//只有第一层级的规格才会有
									Count: i == 0 ? item.Count : '',
									IsCanSubmitOrder: item.IsCanSubmitOrder && i == 0 ? item.IsCanSubmitOrder : false,
								}
								// console.log(item.Count,'data')
								this.formData.sku[i].sku_info.push(data)

								if (i == res.Result.SpecImgSelectLeve) {
									this.formData.sku[i].sku_info[this.formData.sku[i].sku_info.length - 1].pic_url = item.ImgUrl || ''
								}
							} else {
								this.formData.sku[i].sku_info[haveIndex].sku_ids.push(item.Id);
							}
						}
					}
					if (this.$route.query.type == 'copy') {
						item.SellCount = 0
					}
				})
			}
			// console.log(this.formData.sku)
			this.$forceUpdate()
			this.skuDetail = res.Result.ProductSpecList;
			if (res.Result.ProductType == 1) {
				this.skuDetail[0].Stock = Math.min(...res.Result.ProductMixInfoList.map(v => Math.floor(v.Stock / v.ProductCount)))
			} else {
				this.formData.IsShareStock = res.Result.IsShareStock
				//这里要先赋值 不然函数里拿不到值 数量没有赋上去
				this.bunch({ isInfo: true })
				// this.getskuDetail(this.formData.sku,res.Result.ProductSpecList)
			}


			res.Result.ProductThumbImgUrl = res.Result.ProductThumbImgUrl ? [res.Result.ProductThumbImgUrl] : [];
			res.Result.Video = res.Result.Video ? [res.Result.Video] : [];


			this.SharedtotalSku = res.Result.SpecBacthDataList

			for (let item in res.Result) {
				this.formData[item] = res.Result[item];
			}
			this.formData.FreightSettlementTemplateId = this.formData.FreightSettlementTemplateId || ''
			this.formData.FreightTemplateId = this.formData.FreightTemplateId || ''
			this.formData.ProductBuyerId = this.formData.ProductBuyerId || null
			this.formData.OwnBrandProductId = this.formData.OwnBrandProductId || ''

			let totalSku = {
				Stock: res.Result.SpecBacthStock, //库存
				Price: res.Result.SpecBacthPrice, //原价/市场价
				GroupPrice: res.Result.SpecBacthGroupPrice, //团购价
				SpreadPrice: res.Result.SpecBacthSpreadPrice, //差价
				ThirdRolePrice: res.Result.SpecBacthThirdRolePrice, //总代价
				RouTuanPrice: res.Result.SpecBacthRouTuanPrice, //肉团价
				lc_price: res.Result.SpecBacthFirstRolePrice, //联创
				core_price: res.Result.SpecBacthSecondRolePrice, //核心
				ProviderSupplyPrice: res.Result.SpecBacthProviderSupplyPrice, //商家供货价
			}
			// console.log(totalSku,res.Result.SpecBacthFirstRolePrice,res.Result.SpecBacthSecondRolePrice)
			this.copytotalSku = totalSku
			this.totalSku = totalSku

			if (this.formData.ProductType == 1) {
				this.assemblySupplyPrice = this.formData.ProductSpecList[0].ProviderSupplyPrice
			}

			this.getRefundAddressByID(res.Result.ProviderReturnAddressId)
			this.getLogisticsList()
			this.getClassId()
			//点击审核的时候只显示待审核的tab
			if (this.$route.query.type == 'check') {
				this.filterTab()
			} else if (this.$route.query.type == 'change') {
				this.chooseTab = 2
			}
		} catch (e) {
			console.log(e)
			this.isPageLoading = false;
		}
	}
	private filterTab() {
		let arrowlist = this.arrowlist
		if (this.formData.ProductInfoState == 1) {
			arrowlist[0].type = 1
		}
		if (this.formData.ProductMaterialState == 1) {
			arrowlist[1].type = 1
		}
		if (this.formData.ProductAptitudeState == 1) {
			arrowlist[2].type = 1
		}
		if (this.formData.ProductLogisticsState == 1 || this.formData.ProductCheckWarehouseState == 1) {
			arrowlist[3].type = 1
		} else {
			this.flowTablist = []
		}
		// console.log(arrowlist)
		this.arrowlist = arrowlist.filter(v => v.type == 1)
	}
	private getClassId() {
		let id = this.formData.ProductClassId
		for (let item of this.categoryoptions) {
			if (item.Id == id) {
				this.formData.ProductClassId = [item.Id]
				return
			} else if (item.children && item.children.length) {
				for (let item2 of item.children) {
					if (item2.Id == id) {
						this.formData.ProductClassId = [item.Id, item2.Id]
						return
					} else if (item2.children && item2.children.length) {
						for (let item3 of item2.children) {
							if (item3.Id == id) {
								this.formData.ProductClassId = [item.Id, item2.Id, item3.Id]
								return
							}
						}
					} else {
						this.formData.ProductClassId = []
						continue
					}
				}
			} else {
				this.formData.ProductClassId = []
				continue
			}
		}
	}

	private getskuDetail(sku: any, dellist: any) {
		let list: any = []
		dellist.map((j: any) => {
			// console.log(m)
			let num = 0
			let classKey = ''
			for (let i = 0; i < sku.length; i++) {
				info: for (let m = 0; m < sku[i].sku_info.length; m++) {
					let key = 'SpecValue' + (i == 0 ? '' : i + 1)
					if (j[key] == sku[i].sku_info[m].sku_value) {
						num += 1
						classKey += sku[i].sku_info[m].classKey
						break info
					}
				}
			}
			//查找到对应的规格型号对应的数据 并且拼接上每个对应规格型号的classKey
			if (num == sku.length) {
				j.classKey = classKey
				list.push(j)
			}
		})
		this.skuDetail = list
		// console.log(this.skuDetail)
	}

	// 上传图片成功回调
	private uploadSuc(list: any, key: string) {
		this.formData[key] = list
	}

	// 选择退款地址
	private selectRefundAddress(row: any) {
		this.formData.ProviderReturnAddressId = row.Id;
		this.selectRA = row;
		this.showSelectRefundAddress = false
	}

	// 通过id获取退款地址
	private async getRefundAddressByID(id: number) {
		if (!id) return;
		try {
			const res: any = await providerReturnAddressSelectItem({
				ProviderId: this.formData.ProviderId
			});
			var list = res.Result.filter(item => {
				return item.Id == id;
			})
			this.selectRA = list.length ? list[0] : null;
		} catch (e) {
			console.log(e)
		}
	}


	/**
	 * 跳转到供应商模版列表
	 */
	private async getLogisticsList() {


		try {
			const res: any = await productfreightTemplateSelectitem({
				ProviderId: this.formData.ProviderId,
				Skip: 0,
				Take: 99999
			})
			this.logisticsList = res.Result;
			// console.log(this.logisticsList)
		} catch (err) {
			console.log(err);
		}
	}

}
